import React from 'react';
import { StyleSheet } from 'react-native';

import { NavbarLink, type NavbarLinkProps } from '../NavbarLink';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarBackLink = (props: Props) => {
  const { style, ...restProps } = props;

  const linkStyles = [styles.link, style];

  return (
    <NavbarLink
      accessibilityRole="button"
      iconName="IconArrowLeft"
      style={linkStyles}
      {...restProps}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  link: {
    minWidth: 48,
    width: 48,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<
  NavbarLinkProps,
  'accessibilityRole' | 'children' | 'iconName' | 'iconNameActive'
>;
